import Vue from 'vue'
import './plugins/vuetify'
import './plugins/http'
import './plugins/vue-cookie'
import './plugins/vuelidate'
import App from './app.vue'
import router from './router'
import './registerServiceWorker'
import 'roboto-fontface/css/roboto/roboto-fontface.css'
import 'material-design-icons-iconfont/dist/material-design-icons.css'

Vue.config.productionTip = false

new Vue({
  router,
  render: h => h(App)
}).$mount('#app')
